export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="px-6 md:px-8 max-w-4xl mx-auto">
        <div className="bg-background-100 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              如果您有综艺资源推荐、内容合作或使用反馈，欢迎通过以下方式联系我们。
              红桃影院综艺在线观看团队期待与您交流，一起让综艺大全更加精彩。
            </p>
            <div className="flex flex-col gap-3 text-sm text-foreground-600">
              <div className="flex items-center gap-3 justify-center md:justify-start">
                <span className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary-500"></i>
                </span>
                <span>contact@hongtao.tv</span>
              </div>
              <div className="flex items-center gap-3 justify-center md:justify-start">
                <span className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-accent-500"></i>
                </span>
                <span>红桃影院官方公众号</span>
              </div>
            </div>
          </div>
          <a
            href="#faq"
            className="px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-question-answer-line mr-2"></i>
            查看常见问题
          </a>
        </div>
      </div>
    </section>
  );
}